/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { AddPatientIntegrationViewModel } from '../model/addPatientIntegrationViewModel';
// @ts-ignore
import { AddPatientResponseIntegrationViewModel } from '../model/addPatientResponseIntegrationViewModel';
// @ts-ignore
import { DatasetSimpleIntegrationViewModel } from '../model/datasetSimpleIntegrationViewModel';
// @ts-ignore
import { GuarantorDemographicsIntegrationViewModel } from '../model/guarantorDemographicsIntegrationViewModel';
// @ts-ignore
import { ImaginePayBalanceIntegrationViewModel } from '../model/imaginePayBalanceIntegrationViewModel';
// @ts-ignore
import { InsuranceCarrierDetailsIntegrationViewModel } from '../model/insuranceCarrierDetailsIntegrationViewModel';
// @ts-ignore
import { InsuranceCarrierIntegrationViewModel } from '../model/insuranceCarrierIntegrationViewModel';
// @ts-ignore
import { InsuranceTypeIntegrationViewModel } from '../model/insuranceTypeIntegrationViewModel';
// @ts-ignore
import { Operation } from '../model/operation';
// @ts-ignore
import { PartnerSyncSearchViewModel } from '../model/partnerSyncSearchViewModel';
// @ts-ignore
import { PartnerSyncViewModel } from '../model/partnerSyncViewModel';
// @ts-ignore
import { PatientBalanceIntegrationViewModel } from '../model/patientBalanceIntegrationViewModel';
// @ts-ignore
import { PatientDemographicsIntegrationViewModel } from '../model/patientDemographicsIntegrationViewModel';
// @ts-ignore
import { PatientDetailsIntegrationViewModel } from '../model/patientDetailsIntegrationViewModel';
// @ts-ignore
import { PatientInsuranceIntegrationViewModel } from '../model/patientInsuranceIntegrationViewModel';
// @ts-ignore
import { PatientSearchCriteriaIntegrationViewModel } from '../model/patientSearchCriteriaIntegrationViewModel';
// @ts-ignore
import { PatientSearchResultsIntegrationViewModel } from '../model/patientSearchResultsIntegrationViewModel';
// @ts-ignore
import { ProblemDetails } from '../model/problemDetails';
// @ts-ignore
import { ProcedureCodeDetailsIntegrationViewModel } from '../model/procedureCodeDetailsIntegrationViewModel';
// @ts-ignore
import { ProcedureCodeIntegrationViewModel } from '../model/procedureCodeIntegrationViewModel';
// @ts-ignore
import { ProcedureFeeIntegrationViewModel } from '../model/procedureFeeIntegrationViewModel';
// @ts-ignore
import { ProviderDetailsIntegrationViewModel } from '../model/providerDetailsIntegrationViewModel';
// @ts-ignore
import { ProviderIntegrationViewModel } from '../model/providerIntegrationViewModel';
// @ts-ignore
import { UpdateProcedureTransactionIntegrationViewModel } from '../model/updateProcedureTransactionIntegrationViewModel';
// @ts-ignore
import { UpdateVisitIntegrationViewModel } from '../model/updateVisitIntegrationViewModel';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class IntegrationService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          (k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Get balance details for a given patient
   * &lt;b&gt;Use Case: &lt;/b&gt; Get balance information by visit and procedure for a patient.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; This endpoint retrieves patient balance information, with details by visit and procedure.                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;
   * @param accountnumber
   * @param datasetId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationBalanceDetailsAccountnumberGet(
    accountnumber: string,
    datasetId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PatientBalanceIntegrationViewModel>;
  public apiV1IntegrationBalanceDetailsAccountnumberGet(
    accountnumber: string,
    datasetId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PatientBalanceIntegrationViewModel>>;
  public apiV1IntegrationBalanceDetailsAccountnumberGet(
    accountnumber: string,
    datasetId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PatientBalanceIntegrationViewModel>>;
  public apiV1IntegrationBalanceDetailsAccountnumberGet(
    accountnumber: string,
    datasetId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (accountnumber === null || accountnumber === undefined) {
      throw new Error(
        'Required parameter accountnumber was null or undefined when calling apiV1IntegrationBalanceDetailsAccountnumberGet.'
      );
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationBalanceDetailsAccountnumberGet.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<PatientBalanceIntegrationViewModel>(
      `${this.configuration.basePath}/api/v1/integration/balance-details/${encodeURIComponent(String(accountnumber))}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieve all defined datasets for an installation
   * &lt;b&gt;Use Case: &lt;/b&gt; Retrieve all defined datasets for an installation.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt;  Most calls to the Peregrine API require a dataset id passed in an HTTP header.  Use this endpoint to retrieve basic information for each dataset defined in the installation.                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt; A successful call to the Authenticate endpoint to retrieve a valid bearer token. &lt;/li&gt;
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationDatasetAllGet(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Array<DatasetSimpleIntegrationViewModel>>;
  public apiV1IntegrationDatasetAllGet(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Array<DatasetSimpleIntegrationViewModel>>>;
  public apiV1IntegrationDatasetAllGet(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Array<DatasetSimpleIntegrationViewModel>>>;
  public apiV1IntegrationDatasetAllGet(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<Array<DatasetSimpleIntegrationViewModel>>(
      `${this.configuration.basePath}/api/v1/integration/dataset/all`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Delete a procedure transaction by external id
   * &lt;b&gt;Use Case: &lt;/b&gt; Delete a procedure transaction (only for held visits).                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; Delete an existing procedure transaction.                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;
   * @param externalaccountnumber
   * @param externalid
   * @param datasetId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationDeleteProcedureExternalaccountnumberExternalidPost(
    externalaccountnumber: string,
    externalid: string,
    datasetId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any>;
  public apiV1IntegrationDeleteProcedureExternalaccountnumberExternalidPost(
    externalaccountnumber: string,
    externalid: string,
    datasetId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public apiV1IntegrationDeleteProcedureExternalaccountnumberExternalidPost(
    externalaccountnumber: string,
    externalid: string,
    datasetId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public apiV1IntegrationDeleteProcedureExternalaccountnumberExternalidPost(
    externalaccountnumber: string,
    externalid: string,
    datasetId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (externalaccountnumber === null || externalaccountnumber === undefined) {
      throw new Error(
        'Required parameter externalaccountnumber was null or undefined when calling apiV1IntegrationDeleteProcedureExternalaccountnumberExternalidPost.'
      );
    }
    if (externalid === null || externalid === undefined) {
      throw new Error(
        'Required parameter externalid was null or undefined when calling apiV1IntegrationDeleteProcedureExternalaccountnumberExternalidPost.'
      );
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationDeleteProcedureExternalaccountnumberExternalidPost.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.post<any>(
      `${this.configuration.basePath}/api/v1/integration/delete-procedure/${encodeURIComponent(String(externalaccountnumber))}/${encodeURIComponent(String(externalid))}`,
      null,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get fee schedule amounts for procedures
   * &lt;b&gt;Use Case: &lt;/b&gt; Get fee schedule amounts for given procedures, based on insurance carrier, service date, procedure, and modifier                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; Get fee schedule amounts for given procedures                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;
   * @param datasetId
   * @param procedureFeeIntegrationViewModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationGetFeeAmountsPost(
    datasetId: string,
    procedureFeeIntegrationViewModel?: Array<ProcedureFeeIntegrationViewModel>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Array<ProcedureFeeIntegrationViewModel>>;
  public apiV1IntegrationGetFeeAmountsPost(
    datasetId: string,
    procedureFeeIntegrationViewModel?: Array<ProcedureFeeIntegrationViewModel>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Array<ProcedureFeeIntegrationViewModel>>>;
  public apiV1IntegrationGetFeeAmountsPost(
    datasetId: string,
    procedureFeeIntegrationViewModel?: Array<ProcedureFeeIntegrationViewModel>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Array<ProcedureFeeIntegrationViewModel>>>;
  public apiV1IntegrationGetFeeAmountsPost(
    datasetId: string,
    procedureFeeIntegrationViewModel?: Array<ProcedureFeeIntegrationViewModel>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationGetFeeAmountsPost.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.post<Array<ProcedureFeeIntegrationViewModel>>(
      `${this.configuration.basePath}/api/v1/integration/get-fee-amounts`,
      procedureFeeIntegrationViewModel,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update demographics for a guarantor by patient account number
   * &lt;b&gt;Use Case: &lt;/b&gt; Update guarantor demographic information                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; Update guarantor demographic attributes with a PATCH operation, which only requires specification of the fields being updated.                 &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;&lt;li&gt;(optional) A successful call to the Patient Search endpoint to retrieve the requested patient\&#39;s account number if it is not known. &lt;/li&gt;
   * @param accountnumber Patient account number
   * @param datasetId
   * @param operation JSON patch document with guarantor demographics update operations
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationGuarantorDemographicsAccountnumberPatch(
    accountnumber: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<GuarantorDemographicsIntegrationViewModel>;
  public apiV1IntegrationGuarantorDemographicsAccountnumberPatch(
    accountnumber: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<GuarantorDemographicsIntegrationViewModel>>;
  public apiV1IntegrationGuarantorDemographicsAccountnumberPatch(
    accountnumber: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<GuarantorDemographicsIntegrationViewModel>>;
  public apiV1IntegrationGuarantorDemographicsAccountnumberPatch(
    accountnumber: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (accountnumber === null || accountnumber === undefined) {
      throw new Error(
        'Required parameter accountnumber was null or undefined when calling apiV1IntegrationGuarantorDemographicsAccountnumberPatch.'
      );
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationGuarantorDemographicsAccountnumberPatch.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.patch<GuarantorDemographicsIntegrationViewModel>(
      `${this.configuration.basePath}/api/v1/integration/guarantor-demographics/${encodeURIComponent(String(accountnumber))}`,
      operation,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves ImaginePay request info for patient
   * &lt;b&gt;Use Case: &lt;/b&gt; Retrieve ImaginePay details for a patient                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; This endpoint retrieves the imaginepay balance request information for a patient, including the ImaginePay RequestID and OnlineAccountNumber                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;
   * @param imaginepaydataset ImaginePay dataset for the request
   * @param accountnumber Patient\&#39;s account number in Peregrine
   * @param datasetId
   * @param amount Optional amount to charge, rather than using the account\&#39;s patient balance
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationImaginepayDetailsImaginepaydatasetAccountnumberGet(
    imaginepaydataset: string,
    accountnumber: string,
    datasetId: string,
    amount?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<ImaginePayBalanceIntegrationViewModel>;
  public apiV1IntegrationImaginepayDetailsImaginepaydatasetAccountnumberGet(
    imaginepaydataset: string,
    accountnumber: string,
    datasetId: string,
    amount?: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<ImaginePayBalanceIntegrationViewModel>>;
  public apiV1IntegrationImaginepayDetailsImaginepaydatasetAccountnumberGet(
    imaginepaydataset: string,
    accountnumber: string,
    datasetId: string,
    amount?: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<ImaginePayBalanceIntegrationViewModel>>;
  public apiV1IntegrationImaginepayDetailsImaginepaydatasetAccountnumberGet(
    imaginepaydataset: string,
    accountnumber: string,
    datasetId: string,
    amount?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (imaginepaydataset === null || imaginepaydataset === undefined) {
      throw new Error(
        'Required parameter imaginepaydataset was null or undefined when calling apiV1IntegrationImaginepayDetailsImaginepaydatasetAccountnumberGet.'
      );
    }
    if (accountnumber === null || accountnumber === undefined) {
      throw new Error(
        'Required parameter accountnumber was null or undefined when calling apiV1IntegrationImaginepayDetailsImaginepaydatasetAccountnumberGet.'
      );
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationImaginepayDetailsImaginepaydatasetAccountnumberGet.'
      );
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (amount !== undefined && amount !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>amount, 'amount');
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<ImaginePayBalanceIntegrationViewModel>(
      `${this.configuration.basePath}/api/v1/integration/imaginepay-details/${encodeURIComponent(String(imaginepaydataset))}/${encodeURIComponent(String(accountnumber))}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves ImaginePay request info for patient with no balance (for saving credit cards)
   * &lt;b&gt;Use Case: &lt;/b&gt; Creates an imaginepay request for a patient with zero balance, in order to save credit cards                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; This endpoint retrieves the imaginepay request information for a patient, including the ImaginePay RequestID and OnlineAccountNumber                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;
   * @param imaginepaydataset ImaginePay dataset for the request
   * @param accountnumber Patient\&#39;s account number in Peregrine
   * @param datasetId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationImaginepaySaveCardImaginepaydatasetAccountnumberGet(
    imaginepaydataset: string,
    accountnumber: string,
    datasetId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<ImaginePayBalanceIntegrationViewModel>;
  public apiV1IntegrationImaginepaySaveCardImaginepaydatasetAccountnumberGet(
    imaginepaydataset: string,
    accountnumber: string,
    datasetId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<ImaginePayBalanceIntegrationViewModel>>;
  public apiV1IntegrationImaginepaySaveCardImaginepaydatasetAccountnumberGet(
    imaginepaydataset: string,
    accountnumber: string,
    datasetId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<ImaginePayBalanceIntegrationViewModel>>;
  public apiV1IntegrationImaginepaySaveCardImaginepaydatasetAccountnumberGet(
    imaginepaydataset: string,
    accountnumber: string,
    datasetId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (imaginepaydataset === null || imaginepaydataset === undefined) {
      throw new Error(
        'Required parameter imaginepaydataset was null or undefined when calling apiV1IntegrationImaginepaySaveCardImaginepaydatasetAccountnumberGet.'
      );
    }
    if (accountnumber === null || accountnumber === undefined) {
      throw new Error(
        'Required parameter accountnumber was null or undefined when calling apiV1IntegrationImaginepaySaveCardImaginepaydatasetAccountnumberGet.'
      );
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationImaginepaySaveCardImaginepaydatasetAccountnumberGet.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<ImaginePayBalanceIntegrationViewModel>(
      `${this.configuration.basePath}/api/v1/integration/imaginepay-save-card/${encodeURIComponent(String(imaginepaydataset))}/${encodeURIComponent(String(accountnumber))}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Add a new insurance carrier
   * &lt;b&gt;Use Case: &lt;/b&gt; Add a new insurance Carrier to a dataset.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; Add a new insurance Carrier to a dataset.                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;
   * @param datasetId
   * @param insuranceCarrierDetailsIntegrationViewModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationInsuranceCarrierAddPost(
    datasetId: string,
    insuranceCarrierDetailsIntegrationViewModel?: InsuranceCarrierDetailsIntegrationViewModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any>;
  public apiV1IntegrationInsuranceCarrierAddPost(
    datasetId: string,
    insuranceCarrierDetailsIntegrationViewModel?: InsuranceCarrierDetailsIntegrationViewModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public apiV1IntegrationInsuranceCarrierAddPost(
    datasetId: string,
    insuranceCarrierDetailsIntegrationViewModel?: InsuranceCarrierDetailsIntegrationViewModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public apiV1IntegrationInsuranceCarrierAddPost(
    datasetId: string,
    insuranceCarrierDetailsIntegrationViewModel?: InsuranceCarrierDetailsIntegrationViewModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationInsuranceCarrierAddPost.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.post<any>(
      `${this.configuration.basePath}/api/v1/integration/insurance-carrier/add`,
      insuranceCarrierDetailsIntegrationViewModel,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves an insurance carrier by code
   * &lt;b&gt;Use Case: &lt;/b&gt; Retrieve an insurance carrier by code to view carrier details.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; This endpoint retrieves a specific insurance carrier by code for the given dataset. The insurance carrier data can be used to assign carriers to a patient in Update Patient Insurance, or to sync details with an external system.                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;
   * @param code
   * @param datasetId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationInsuranceCarrierCodeGet(
    code: string,
    datasetId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Array<InsuranceCarrierDetailsIntegrationViewModel>>;
  public apiV1IntegrationInsuranceCarrierCodeGet(
    code: string,
    datasetId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Array<InsuranceCarrierDetailsIntegrationViewModel>>>;
  public apiV1IntegrationInsuranceCarrierCodeGet(
    code: string,
    datasetId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Array<InsuranceCarrierDetailsIntegrationViewModel>>>;
  public apiV1IntegrationInsuranceCarrierCodeGet(
    code: string,
    datasetId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (code === null || code === undefined) {
      throw new Error(
        'Required parameter code was null or undefined when calling apiV1IntegrationInsuranceCarrierCodeGet.'
      );
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationInsuranceCarrierCodeGet.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<Array<InsuranceCarrierDetailsIntegrationViewModel>>(
      `${this.configuration.basePath}/api/v1/integration/insurance-carrier/${encodeURIComponent(String(code))}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update an insurance carrier
   * &lt;b&gt;Use Case: &lt;/b&gt; Update details for an insurance carrier                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; Update insurance carrier attributes with a PATCH operation, which only requires specification of the fields being updated.                 &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;&lt;li&gt;(optional) A successful call to the Get Insurance Carriers endpoint to retrieve the requested carrier\&#39;s code, if it is not known. &lt;/li&gt;
   * @param code Insurance Carrier code
   * @param datasetId
   * @param operation JSON patch document with insurace carrier update operations
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationInsuranceCarrierUpdateCodePatch(
    code: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<InsuranceCarrierDetailsIntegrationViewModel>;
  public apiV1IntegrationInsuranceCarrierUpdateCodePatch(
    code: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<InsuranceCarrierDetailsIntegrationViewModel>>;
  public apiV1IntegrationInsuranceCarrierUpdateCodePatch(
    code: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<InsuranceCarrierDetailsIntegrationViewModel>>;
  public apiV1IntegrationInsuranceCarrierUpdateCodePatch(
    code: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (code === null || code === undefined) {
      throw new Error(
        'Required parameter code was null or undefined when calling apiV1IntegrationInsuranceCarrierUpdateCodePatch.'
      );
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationInsuranceCarrierUpdateCodePatch.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.patch<InsuranceCarrierDetailsIntegrationViewModel>(
      `${this.configuration.basePath}/api/v1/integration/insurance-carrier/update/${encodeURIComponent(String(code))}`,
      operation,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves all insurance carriers (optionally by dataset)
   * &lt;b&gt;Use Case: &lt;/b&gt; Retrieve all defined insurance carriers for purposes of assigning to patients.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; To assign insurance carriers to a patient in Update Patient Insurance, the carrier code or the carrier name and address information is required.  This endpoint retrieves all defined insurance carriers for either all datasets or a single dataset.                 &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;(optional) A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;
   * @param datasetid
   * @param datasetId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationInsuranceCarriersDatasetidGet(
    datasetid: string,
    datasetId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Array<InsuranceCarrierIntegrationViewModel>>;
  public apiV1IntegrationInsuranceCarriersDatasetidGet(
    datasetid: string,
    datasetId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Array<InsuranceCarrierIntegrationViewModel>>>;
  public apiV1IntegrationInsuranceCarriersDatasetidGet(
    datasetid: string,
    datasetId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Array<InsuranceCarrierIntegrationViewModel>>>;
  public apiV1IntegrationInsuranceCarriersDatasetidGet(
    datasetid: string,
    datasetId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (datasetid === null || datasetid === undefined) {
      throw new Error(
        'Required parameter datasetid was null or undefined when calling apiV1IntegrationInsuranceCarriersDatasetidGet.'
      );
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationInsuranceCarriersDatasetidGet.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<Array<InsuranceCarrierIntegrationViewModel>>(
      `${this.configuration.basePath}/api/v1/integration/insurance-carriers/${encodeURIComponent(String(datasetid))}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves all insurance types
   * &lt;b&gt;Use Case: &lt;/b&gt; Retrieve all insurance types (not dataset specific)                 &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; To assign insurance types to a patient\&#39;s insurance in &#x60;Update Patient Insurance&#x60;, a list of insurance type codes is required.  This endpoint retrieves these codes and their corresponding names.                 &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;
   * @param datasetId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationInsuranceTypesGet(
    datasetId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Array<InsuranceTypeIntegrationViewModel>>;
  public apiV1IntegrationInsuranceTypesGet(
    datasetId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Array<InsuranceTypeIntegrationViewModel>>>;
  public apiV1IntegrationInsuranceTypesGet(
    datasetId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Array<InsuranceTypeIntegrationViewModel>>>;
  public apiV1IntegrationInsuranceTypesGet(
    datasetId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationInsuranceTypesGet.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<Array<InsuranceTypeIntegrationViewModel>>(
      `${this.configuration.basePath}/api/v1/integration/insurance-types`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieve complete patient data by account number
   * &lt;b&gt;Use Case: &lt;/b&gt; Retrieve detailed information for a single patient by account number.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; Retrieve details for a single patient, including patient demographics, guarantor demographics, insurance policy and carrier information, dates of service, and patient/insurance balances.                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token. &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;&lt;li&gt;(optionally) A successful call to the Patient Search endpoint to retrieve the requested patient\&#39;s account number if it is not known.&lt;/li&gt;
   * @param accountnumber patient account number available from search results
   * @param datasetId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationPatientAccountnumberGet(
    accountnumber: string,
    datasetId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PatientDetailsIntegrationViewModel>;
  public apiV1IntegrationPatientAccountnumberGet(
    accountnumber: string,
    datasetId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PatientDetailsIntegrationViewModel>>;
  public apiV1IntegrationPatientAccountnumberGet(
    accountnumber: string,
    datasetId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PatientDetailsIntegrationViewModel>>;
  public apiV1IntegrationPatientAccountnumberGet(
    accountnumber: string,
    datasetId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (accountnumber === null || accountnumber === undefined) {
      throw new Error(
        'Required parameter accountnumber was null or undefined when calling apiV1IntegrationPatientAccountnumberGet.'
      );
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationPatientAccountnumberGet.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<PatientDetailsIntegrationViewModel>(
      `${this.configuration.basePath}/api/v1/integration/patient/${encodeURIComponent(String(accountnumber))}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Add a new patient account
   * &lt;b&gt;Use Case: &lt;/b&gt; Add a new patient account with or without visits. Update patient demos, add new visits for accounts previously added through this endpoint.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; Add a new patient account to the system with guarantor and insurance information, visit and procedures. Incomplete patients are allowed, and will be sent to the Demographic Import Errors queue for completion by a user or subsequent api call. Incomplete visits will be sent to the Procedure Import Errors queue.                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;&lt;li&gt;(optional) A successful call to the Insurance Carriers endpoint to retrieve available insurance carriers. &lt;/li&gt;&lt;li&gt;(optional) A successful call to the Insurance Types endpoint to retrieve insurance types. &lt;/li&gt;&lt;li&gt;(optional) For updates to patients previously added to this endpoint, the External Account Number field must match the original patient’s external account number. The external account number should be unique for each patient, and is separate from the patient’s account number in Peregrine. &lt;/li&gt;
   * @param datasetId
   * @param addPatientIntegrationViewModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationPatientAddPost(
    datasetId: string,
    addPatientIntegrationViewModel?: AddPatientIntegrationViewModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<AddPatientResponseIntegrationViewModel>;
  public apiV1IntegrationPatientAddPost(
    datasetId: string,
    addPatientIntegrationViewModel?: AddPatientIntegrationViewModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<AddPatientResponseIntegrationViewModel>>;
  public apiV1IntegrationPatientAddPost(
    datasetId: string,
    addPatientIntegrationViewModel?: AddPatientIntegrationViewModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<AddPatientResponseIntegrationViewModel>>;
  public apiV1IntegrationPatientAddPost(
    datasetId: string,
    addPatientIntegrationViewModel?: AddPatientIntegrationViewModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationPatientAddPost.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.post<AddPatientResponseIntegrationViewModel>(
      `${this.configuration.basePath}/api/v1/integration/patient/add`,
      addPatientIntegrationViewModel,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update demographics for a patient by account number
   * &lt;b&gt;Use Case: &lt;/b&gt; Update patient demographic information                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; Update patient demographic attributes with a PATCH operation, which only requires specification of the fields being updated.                 &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;&lt;li&gt;(optional) A successful call to the Patient Search endpoint to retrieve the requested patient\&#39;s account number if it is not known. &lt;/li&gt;
   * @param accountnumber Patient account number
   * @param datasetId
   * @param operation JSON patch document with patient demographic update operations
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationPatientDemographicsAccountnumberPatch(
    accountnumber: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<PatientDemographicsIntegrationViewModel>;
  public apiV1IntegrationPatientDemographicsAccountnumberPatch(
    accountnumber: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<PatientDemographicsIntegrationViewModel>>;
  public apiV1IntegrationPatientDemographicsAccountnumberPatch(
    accountnumber: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<PatientDemographicsIntegrationViewModel>>;
  public apiV1IntegrationPatientDemographicsAccountnumberPatch(
    accountnumber: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (accountnumber === null || accountnumber === undefined) {
      throw new Error(
        'Required parameter accountnumber was null or undefined when calling apiV1IntegrationPatientDemographicsAccountnumberPatch.'
      );
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationPatientDemographicsAccountnumberPatch.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.patch<PatientDemographicsIntegrationViewModel>(
      `${this.configuration.basePath}/api/v1/integration/patient-demographics/${encodeURIComponent(String(accountnumber))}`,
      operation,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update insurance for a patient by account number
   * &lt;b&gt;Use Case: &lt;/b&gt; Update patient insurance information with carrier and policy information.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; Update patient insurance information at a specified level (primary, secondary, tertiary) with the provided policy and carrier information.                 &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;&lt;li&gt;A successful call to the Insurance Carriers endpoint to retrieve available insurance carriers. &lt;/li&gt;&lt;li&gt;A successful call to the Insurance Types endpoint to retrieve insurance types. &lt;/li&gt;
   * @param accountnumber Patient account number
   * @param datasetId
   * @param patientInsuranceIntegrationViewModel Patient insurance information
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationPatientInsuranceAccountnumberPost(
    accountnumber: string,
    datasetId: string,
    patientInsuranceIntegrationViewModel?: PatientInsuranceIntegrationViewModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Array<PatientInsuranceIntegrationViewModel>>;
  public apiV1IntegrationPatientInsuranceAccountnumberPost(
    accountnumber: string,
    datasetId: string,
    patientInsuranceIntegrationViewModel?: PatientInsuranceIntegrationViewModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Array<PatientInsuranceIntegrationViewModel>>>;
  public apiV1IntegrationPatientInsuranceAccountnumberPost(
    accountnumber: string,
    datasetId: string,
    patientInsuranceIntegrationViewModel?: PatientInsuranceIntegrationViewModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Array<PatientInsuranceIntegrationViewModel>>>;
  public apiV1IntegrationPatientInsuranceAccountnumberPost(
    accountnumber: string,
    datasetId: string,
    patientInsuranceIntegrationViewModel?: PatientInsuranceIntegrationViewModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (accountnumber === null || accountnumber === undefined) {
      throw new Error(
        'Required parameter accountnumber was null or undefined when calling apiV1IntegrationPatientInsuranceAccountnumberPost.'
      );
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationPatientInsuranceAccountnumberPost.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.post<Array<PatientInsuranceIntegrationViewModel>>(
      `${this.configuration.basePath}/api/v1/integration/patient-insurance/${encodeURIComponent(String(accountnumber))}`,
      patientInsuranceIntegrationViewModel,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Patient search returning basic patient information
   * &lt;b&gt;Use Case: &lt;/b&gt; Search for patients within a dataset to retrieve one, many, or all patients.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; Search for patients by account number, MRN, last name, first name, or birth date. Returns an array of entities with basic patient information. If the request contains no search criteria, the response returns all patients (subject to paging parameters). If request contains Page and PageSize, the results contain only those entities in the page\&#39;s range.                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token. &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids. &lt;/li&gt;
   * @param datasetId
   * @param patientSearchCriteriaIntegrationViewModel Patient search criteria
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationPatientSearchPost(
    datasetId: string,
    patientSearchCriteriaIntegrationViewModel?: PatientSearchCriteriaIntegrationViewModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Array<PatientSearchResultsIntegrationViewModel>>;
  public apiV1IntegrationPatientSearchPost(
    datasetId: string,
    patientSearchCriteriaIntegrationViewModel?: PatientSearchCriteriaIntegrationViewModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Array<PatientSearchResultsIntegrationViewModel>>>;
  public apiV1IntegrationPatientSearchPost(
    datasetId: string,
    patientSearchCriteriaIntegrationViewModel?: PatientSearchCriteriaIntegrationViewModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Array<PatientSearchResultsIntegrationViewModel>>>;
  public apiV1IntegrationPatientSearchPost(
    datasetId: string,
    patientSearchCriteriaIntegrationViewModel?: PatientSearchCriteriaIntegrationViewModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationPatientSearchPost.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.post<Array<PatientSearchResultsIntegrationViewModel>>(
      `${this.configuration.basePath}/api/v1/integration/patient/search`,
      patientSearchCriteriaIntegrationViewModel,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Add a new procedure code
   * &lt;b&gt;Use Case: &lt;/b&gt; Add a new procedure code to a dataset.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; Add a new procedure code to a dataset.                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;
   * @param datasetId
   * @param procedureCodeDetailsIntegrationViewModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationProcedureAddPost(
    datasetId: string,
    procedureCodeDetailsIntegrationViewModel?: ProcedureCodeDetailsIntegrationViewModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any>;
  public apiV1IntegrationProcedureAddPost(
    datasetId: string,
    procedureCodeDetailsIntegrationViewModel?: ProcedureCodeDetailsIntegrationViewModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public apiV1IntegrationProcedureAddPost(
    datasetId: string,
    procedureCodeDetailsIntegrationViewModel?: ProcedureCodeDetailsIntegrationViewModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public apiV1IntegrationProcedureAddPost(
    datasetId: string,
    procedureCodeDetailsIntegrationViewModel?: ProcedureCodeDetailsIntegrationViewModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationProcedureAddPost.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.post<any>(
      `${this.configuration.basePath}/api/v1/integration/procedure/add`,
      procedureCodeDetailsIntegrationViewModel,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves a procedure by id
   * &lt;b&gt;Use Case: &lt;/b&gt; Retrieve a procedure by id to view procedure details.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; This endpoint retrieves a specific procedure by id for the given dataset.                 &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;
   * @param id
   * @param datasetId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationProcedureByIdIdGet(
    id: string,
    datasetId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<ProcedureCodeDetailsIntegrationViewModel>;
  public apiV1IntegrationProcedureByIdIdGet(
    id: string,
    datasetId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<ProcedureCodeDetailsIntegrationViewModel>>;
  public apiV1IntegrationProcedureByIdIdGet(
    id: string,
    datasetId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<ProcedureCodeDetailsIntegrationViewModel>>;
  public apiV1IntegrationProcedureByIdIdGet(
    id: string,
    datasetId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling apiV1IntegrationProcedureByIdIdGet.');
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationProcedureByIdIdGet.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<ProcedureCodeDetailsIntegrationViewModel>(
      `${this.configuration.basePath}/api/v1/integration/procedure-by-id/${encodeURIComponent(String(id))}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves procedure by code
   * &lt;b&gt;Use Case: &lt;/b&gt; Retrieve a procedure by code to view procedure details.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; This endpoint retrieves a specific procedure by code for the given dataset. Since procedure codes do not have to be unique, a list is returned with all matching values                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;
   * @param code
   * @param datasetId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationProcedureCodeGet(
    code: string,
    datasetId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Array<ProcedureCodeDetailsIntegrationViewModel>>;
  public apiV1IntegrationProcedureCodeGet(
    code: string,
    datasetId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Array<ProcedureCodeDetailsIntegrationViewModel>>>;
  public apiV1IntegrationProcedureCodeGet(
    code: string,
    datasetId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Array<ProcedureCodeDetailsIntegrationViewModel>>>;
  public apiV1IntegrationProcedureCodeGet(
    code: string,
    datasetId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (code === null || code === undefined) {
      throw new Error('Required parameter code was null or undefined when calling apiV1IntegrationProcedureCodeGet.');
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationProcedureCodeGet.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<Array<ProcedureCodeDetailsIntegrationViewModel>>(
      `${this.configuration.basePath}/api/v1/integration/procedure/${encodeURIComponent(String(code))}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves all procedures
   * &lt;b&gt;Use Case: &lt;/b&gt; Retrieve all defined procedure codes.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; This endpoint retrieves all defined procedure codes.                 &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;(optional) A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;
   * @param datasetId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationProcedureGet(
    datasetId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Array<ProcedureCodeIntegrationViewModel>>;
  public apiV1IntegrationProcedureGet(
    datasetId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Array<ProcedureCodeIntegrationViewModel>>>;
  public apiV1IntegrationProcedureGet(
    datasetId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Array<ProcedureCodeIntegrationViewModel>>>;
  public apiV1IntegrationProcedureGet(
    datasetId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (datasetId === null || datasetId === undefined) {
      throw new Error('Required parameter datasetId was null or undefined when calling apiV1IntegrationProcedureGet.');
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<Array<ProcedureCodeIntegrationViewModel>>(
      `${this.configuration.basePath}/api/v1/integration/procedure`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update a procedure
   * &lt;b&gt;Use Case: &lt;/b&gt; Update details for a procedure                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; Update procedure code attributes with a PATCH operation, which only requires specification of the fields being updated.                 &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;&lt;li&gt;(optional) A successful call to the Get Procedures endpoint to retrieve the requested procedure\&#39;s id, if it is not known. &lt;/li&gt;
   * @param id Procedure Code Id
   * @param datasetId
   * @param operation JSON patch document with procedure update operations
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationProcedureUpdateIdPatch(
    id: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<ProcedureCodeDetailsIntegrationViewModel>;
  public apiV1IntegrationProcedureUpdateIdPatch(
    id: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<ProcedureCodeDetailsIntegrationViewModel>>;
  public apiV1IntegrationProcedureUpdateIdPatch(
    id: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<ProcedureCodeDetailsIntegrationViewModel>>;
  public apiV1IntegrationProcedureUpdateIdPatch(
    id: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling apiV1IntegrationProcedureUpdateIdPatch.'
      );
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationProcedureUpdateIdPatch.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.patch<ProcedureCodeDetailsIntegrationViewModel>(
      `${this.configuration.basePath}/api/v1/integration/procedure/update/${encodeURIComponent(String(id))}`,
      operation,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Process ImaginePay payment for a given account
   * &lt;b&gt;Use Case: &lt;/b&gt; Applies imaginepay payment to a patient\&#39;s account                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; This endpoint retrieves payment information from imaginepay for a given account, and applies the payment to the patient account.                 &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;
   * @param accountnumber
   * @param datasetId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationProcessPaymentAccountnumberGet(
    accountnumber: string,
    datasetId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any>;
  public apiV1IntegrationProcessPaymentAccountnumberGet(
    accountnumber: string,
    datasetId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public apiV1IntegrationProcessPaymentAccountnumberGet(
    accountnumber: string,
    datasetId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public apiV1IntegrationProcessPaymentAccountnumberGet(
    accountnumber: string,
    datasetId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (accountnumber === null || accountnumber === undefined) {
      throw new Error(
        'Required parameter accountnumber was null or undefined when calling apiV1IntegrationProcessPaymentAccountnumberGet.'
      );
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationProcessPaymentAccountnumberGet.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<any>(
      `${this.configuration.basePath}/api/v1/integration/process-payment/${encodeURIComponent(String(accountnumber))}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Add a new provider
   * &lt;b&gt;Use Case: &lt;/b&gt; Add a new provider to a dataset.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; Add a new provider to a dataset.                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;
   * @param datasetId
   * @param providerDetailsIntegrationViewModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationProviderAddPost(
    datasetId: string,
    providerDetailsIntegrationViewModel?: ProviderDetailsIntegrationViewModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any>;
  public apiV1IntegrationProviderAddPost(
    datasetId: string,
    providerDetailsIntegrationViewModel?: ProviderDetailsIntegrationViewModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public apiV1IntegrationProviderAddPost(
    datasetId: string,
    providerDetailsIntegrationViewModel?: ProviderDetailsIntegrationViewModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public apiV1IntegrationProviderAddPost(
    datasetId: string,
    providerDetailsIntegrationViewModel?: ProviderDetailsIntegrationViewModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationProviderAddPost.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.post<any>(
      `${this.configuration.basePath}/api/v1/integration/provider/add`,
      providerDetailsIntegrationViewModel,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves all attending providers
   * &lt;b&gt;Use Case: &lt;/b&gt; Retrieve all defined attending providers.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; This endpoint retrieves all defined attending providers.                 &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;(optional) A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;
   * @param datasetId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationProviderAttendingGet(
    datasetId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Array<ProviderIntegrationViewModel>>;
  public apiV1IntegrationProviderAttendingGet(
    datasetId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Array<ProviderIntegrationViewModel>>>;
  public apiV1IntegrationProviderAttendingGet(
    datasetId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Array<ProviderIntegrationViewModel>>>;
  public apiV1IntegrationProviderAttendingGet(
    datasetId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationProviderAttendingGet.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<Array<ProviderIntegrationViewModel>>(
      `${this.configuration.basePath}/api/v1/integration/provider/attending`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves provider by provider code.
   * &lt;b&gt;Use Case: &lt;/b&gt; Retrieve a provider by provider code to view provider details.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; This endpoint retrieves a specific provider by provider code for the given dataset.                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;
   * @param code
   * @param datasetId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationProviderCodeGet(
    code: string,
    datasetId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Array<ProviderDetailsIntegrationViewModel>>;
  public apiV1IntegrationProviderCodeGet(
    code: string,
    datasetId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Array<ProviderDetailsIntegrationViewModel>>>;
  public apiV1IntegrationProviderCodeGet(
    code: string,
    datasetId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Array<ProviderDetailsIntegrationViewModel>>>;
  public apiV1IntegrationProviderCodeGet(
    code: string,
    datasetId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (code === null || code === undefined) {
      throw new Error('Required parameter code was null or undefined when calling apiV1IntegrationProviderCodeGet.');
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationProviderCodeGet.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<Array<ProviderDetailsIntegrationViewModel>>(
      `${this.configuration.basePath}/api/v1/integration/provider/${encodeURIComponent(String(code))}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves all providers
   * &lt;b&gt;Use Case: &lt;/b&gt; Retrieve all defined providers.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; This endpoint retrieves all defined providers.                 &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;(optional) A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;
   * @param datasetId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationProviderGet(
    datasetId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Array<ProviderIntegrationViewModel>>;
  public apiV1IntegrationProviderGet(
    datasetId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Array<ProviderIntegrationViewModel>>>;
  public apiV1IntegrationProviderGet(
    datasetId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Array<ProviderIntegrationViewModel>>>;
  public apiV1IntegrationProviderGet(
    datasetId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (datasetId === null || datasetId === undefined) {
      throw new Error('Required parameter datasetId was null or undefined when calling apiV1IntegrationProviderGet.');
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<Array<ProviderIntegrationViewModel>>(
      `${this.configuration.basePath}/api/v1/integration/provider`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update a provider
   * &lt;b&gt;Use Case: &lt;/b&gt; Update details for a provider                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; Update provider attributes with a PATCH operation, which only requires specification of the fields being updated.                 &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;&lt;li&gt;(optional) A successful call to the Get Provider endpoint to retrieve the requested provider code, if it is not known. &lt;/li&gt;
   * @param number
   * @param datasetId
   * @param operation JSON patch document with provider update operations
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationProviderUpdateNumberPatch(
    number: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<ProviderIntegrationViewModel>;
  public apiV1IntegrationProviderUpdateNumberPatch(
    number: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<ProviderIntegrationViewModel>>;
  public apiV1IntegrationProviderUpdateNumberPatch(
    number: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<ProviderIntegrationViewModel>>;
  public apiV1IntegrationProviderUpdateNumberPatch(
    number: string,
    datasetId: string,
    operation?: Array<Operation>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (number === null || number === undefined) {
      throw new Error(
        'Required parameter number was null or undefined when calling apiV1IntegrationProviderUpdateNumberPatch.'
      );
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationProviderUpdateNumberPatch.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.patch<ProviderIntegrationViewModel>(
      `${this.configuration.basePath}/api/v1/integration/provider/update/${encodeURIComponent(String(number))}`,
      operation,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get sync request history
   * &lt;b&gt;Use Case: &lt;/b&gt; Get sync request history for given criteria.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; Get sync request history.                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;
   * @param datasetId
   * @param partnerSyncSearchViewModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationSyncHistoryPost(
    datasetId: string,
    partnerSyncSearchViewModel?: PartnerSyncSearchViewModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<Array<PartnerSyncViewModel>>;
  public apiV1IntegrationSyncHistoryPost(
    datasetId: string,
    partnerSyncSearchViewModel?: PartnerSyncSearchViewModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<Array<PartnerSyncViewModel>>>;
  public apiV1IntegrationSyncHistoryPost(
    datasetId: string,
    partnerSyncSearchViewModel?: PartnerSyncSearchViewModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<Array<PartnerSyncViewModel>>>;
  public apiV1IntegrationSyncHistoryPost(
    datasetId: string,
    partnerSyncSearchViewModel?: PartnerSyncSearchViewModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationSyncHistoryPost.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.post<Array<PartnerSyncViewModel>>(
      `${this.configuration.basePath}/api/v1/integration/sync-history`,
      partnerSyncSearchViewModel,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Test endpoint for integration
   * @param datasetId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationTestGet(
    datasetId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any>;
  public apiV1IntegrationTestGet(
    datasetId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public apiV1IntegrationTestGet(
    datasetId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public apiV1IntegrationTestGet(
    datasetId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (datasetId === null || datasetId === undefined) {
      throw new Error('Required parameter datasetId was null or undefined when calling apiV1IntegrationTestGet.');
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.get<any>(`${this.configuration.basePath}/api/v1/integration/test`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  /**
   * Update a procedure transaction by external id
   * &lt;b&gt;Use Case: &lt;/b&gt; Update details for an existing procedure transaction.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; Update an existing procedure transaction.                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;
   * @param externalaccountnumber
   * @param externalid
   * @param datasetId
   * @param updateProcedureTransactionIntegrationViewModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationUpdateProcedureExternalaccountnumberExternalidPost(
    externalaccountnumber: string,
    externalid: string,
    datasetId: string,
    updateProcedureTransactionIntegrationViewModel?: UpdateProcedureTransactionIntegrationViewModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any>;
  public apiV1IntegrationUpdateProcedureExternalaccountnumberExternalidPost(
    externalaccountnumber: string,
    externalid: string,
    datasetId: string,
    updateProcedureTransactionIntegrationViewModel?: UpdateProcedureTransactionIntegrationViewModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public apiV1IntegrationUpdateProcedureExternalaccountnumberExternalidPost(
    externalaccountnumber: string,
    externalid: string,
    datasetId: string,
    updateProcedureTransactionIntegrationViewModel?: UpdateProcedureTransactionIntegrationViewModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public apiV1IntegrationUpdateProcedureExternalaccountnumberExternalidPost(
    externalaccountnumber: string,
    externalid: string,
    datasetId: string,
    updateProcedureTransactionIntegrationViewModel?: UpdateProcedureTransactionIntegrationViewModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (externalaccountnumber === null || externalaccountnumber === undefined) {
      throw new Error(
        'Required parameter externalaccountnumber was null or undefined when calling apiV1IntegrationUpdateProcedureExternalaccountnumberExternalidPost.'
      );
    }
    if (externalid === null || externalid === undefined) {
      throw new Error(
        'Required parameter externalid was null or undefined when calling apiV1IntegrationUpdateProcedureExternalaccountnumberExternalidPost.'
      );
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationUpdateProcedureExternalaccountnumberExternalidPost.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.post<any>(
      `${this.configuration.basePath}/api/v1/integration/update-procedure/${encodeURIComponent(String(externalaccountnumber))}/${encodeURIComponent(String(externalid))}`,
      updateProcedureTransactionIntegrationViewModel,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update a visit by external id
   * &lt;b&gt;Use Case: &lt;/b&gt; Update details for an existing visit.                &lt;/br&gt;&lt;b&gt;Summary: &lt;/b&gt; Update an existing visit.                &lt;/br&gt;&lt;b&gt;Prerequisite Steps: &lt;/b&gt;&lt;li&gt;A successful call to the Authenticate endpoint to retrieve a valid bearer token.  &lt;/li&gt;&lt;li&gt;A successful call to the Get Datasets endpoint to retrieve the set of valid dataset ids.&lt;/li&gt;
   * @param externalaccountnumber
   * @param externalid
   * @param datasetId
   * @param updateVisitIntegrationViewModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiV1IntegrationUpdateVisitExternalaccountnumberExternalidPost(
    externalaccountnumber: string,
    externalid: string,
    datasetId: string,
    updateVisitIntegrationViewModel?: UpdateVisitIntegrationViewModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any>;
  public apiV1IntegrationUpdateVisitExternalaccountnumberExternalidPost(
    externalaccountnumber: string,
    externalid: string,
    datasetId: string,
    updateVisitIntegrationViewModel?: UpdateVisitIntegrationViewModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<any>>;
  public apiV1IntegrationUpdateVisitExternalaccountnumberExternalidPost(
    externalaccountnumber: string,
    externalid: string,
    datasetId: string,
    updateVisitIntegrationViewModel?: UpdateVisitIntegrationViewModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<any>>;
  public apiV1IntegrationUpdateVisitExternalaccountnumberExternalidPost(
    externalaccountnumber: string,
    externalid: string,
    datasetId: string,
    updateVisitIntegrationViewModel?: UpdateVisitIntegrationViewModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    if (externalaccountnumber === null || externalaccountnumber === undefined) {
      throw new Error(
        'Required parameter externalaccountnumber was null or undefined when calling apiV1IntegrationUpdateVisitExternalaccountnumberExternalidPost.'
      );
    }
    if (externalid === null || externalid === undefined) {
      throw new Error(
        'Required parameter externalid was null or undefined when calling apiV1IntegrationUpdateVisitExternalaccountnumberExternalidPost.'
      );
    }
    if (datasetId === null || datasetId === undefined) {
      throw new Error(
        'Required parameter datasetId was null or undefined when calling apiV1IntegrationUpdateVisitExternalaccountnumberExternalidPost.'
      );
    }

    let localVarHeaders = this.defaultHeaders;
    if (datasetId !== undefined && datasetId !== null) {
      localVarHeaders = localVarHeaders.set('DatasetId', String(datasetId));
    }

    let localVarCredential: string | undefined;
    // authentication (Bearer) required
    localVarCredential = this.configuration.lookupCredential('Bearer');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    return this.httpClient.post<any>(
      `${this.configuration.basePath}/api/v1/integration/update-visit/${encodeURIComponent(String(externalaccountnumber))}/${encodeURIComponent(String(externalid))}`,
      updateVisitIntegrationViewModel,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
}
